import * as Redux from "redux";
import { MainState } from "../../Core/reducers";
import { QueryCondition } from "../../misc/api/apiTypes";
import { ReprocessCoughSessionListActions, ShowModalAction } from "./Modals/ReprocessCoughSessionModal/ReprocessCoughSessionModalActions";

export const ShowReprocessModalAction = ShowModalAction;

export enum CoughSessionsListActionType {
    FilterChange = 'FilterChange',
    PageChange = 'PageChange',
    SortChange = 'SortChange',
    UnassignDeviceModalVisiblility = 'UnassignDeviceModalVisiblility',
    TrackingNumberModalVisibility = 'TrackingNumberModalVisibility',
    PrimaryAnalysisSetVisibility = 'PrimaryAnalysisSetVisibility',
    PostalModalVisibility = 'PostalModalVisibility',
    ClearAllFilters = 'ClearAllFilters',
    ClearCoughSessions = 'ClearCoughSessions',
    LoadCoughSessions = 'LoadCoughSessions',
    LoadStatuses = 'LoadStatuses',
    LoadSerialNumbers = 'LoadSerialNumbers',
    TrackingNumberSet = 'TrackingNumberSet',
    TrackingNumberSetFailed = 'TrackingNumberSetFailed',
    PrimaryAnalysisSet = 'PrimaryAnalysisSet',
    PrimaryAnalysisSetFailed = 'PrimaryAnalysisSetFailed',
    SelectPrimaryAnalysisSet = 'SelectPrimaryAnalysisSet',
    SubmittingPrimaryAnalysisSet = 'SubmittingPrimaryAnalysisSet',
    ShowAuditTrailPrimaryAnalysisSet = 'ShowAuditTrailPrimaryAnalysisSet'
}

export type CoughSessionsListAction = FilterChangeAction | PageChangeAction | SortChangeAction | UnassignDeviceModalVisiblilityAction |
    PrimaryAnalysisSetVisibilityAction | ClearAllFiltersAction | ClearCoughSessionsAction | LoadCoughSessionsAction | LoadStatusesAction | LoadSerialNumbersAction | TrackingNumberSetAction | TrackingNumberSetFailedAction |
    ReprocessCoughSessionListActions; 

declare var rootUrl: string;

class ClearCoughSessionsAction implements Redux.Action {
    type: CoughSessionsListActionType.ClearCoughSessions;

    static create(): ClearCoughSessionsAction {
        return {
            type: CoughSessionsListActionType.ClearCoughSessions,
        };
    }
}

class LoadCoughSessionsAction implements Redux.Action {
    type: CoughSessionsListActionType.LoadCoughSessions;
    data;

    static create(response): LoadCoughSessionsAction {
        return {
            type: CoughSessionsListActionType.LoadCoughSessions,
            data: response,
        };
    }
}

export class FilterChangeAction implements Redux.Action {
    type: CoughSessionsListActionType.FilterChange;
    member: string;
    condition: QueryCondition;
    value: any;

    static create(member: string, condition: QueryCondition, value: any): FilterChangeAction {
        return {
            type: CoughSessionsListActionType.FilterChange,
            member: member,
            condition: condition,
            value: value,
        };
    }
}

export class PageChangeAction implements Redux.Action {
    type: CoughSessionsListActionType.PageChange;
    page: number;

    static create(page: number): PageChangeAction {
        return {
            type: CoughSessionsListActionType.PageChange,
            page: page,
        };
    }
}

export class SortChangeAction implements Redux.Action {
    type: CoughSessionsListActionType.SortChange;
    member: string;

    static create(member: string): SortChangeAction {
        return {
            type: CoughSessionsListActionType.SortChange,
            member: member,
        };
    }
}

export class UnassignDeviceModalVisiblilityAction implements Redux.Action {
    type: CoughSessionsListActionType.UnassignDeviceModalVisiblility;
    show: boolean;
    record: any;

    static create(show: boolean = true, record: any): UnassignDeviceModalVisiblilityAction {
        return {
            type: CoughSessionsListActionType.UnassignDeviceModalVisiblility,
            show: show,
            record: record,
        };
    }
}

export class PrimaryAnalysisSetVisibilityAction implements Redux.Action {
    type: CoughSessionsListActionType.PrimaryAnalysisSetVisibility;
    show: boolean;
    record: any;

    static create(show: boolean = true, record: any): PrimaryAnalysisSetVisibilityAction {
        return {
            type: CoughSessionsListActionType.PrimaryAnalysisSetVisibility,
            show: show,
            record: record,
        };
    }
}

export class ClearAllFiltersAction implements Redux.Action {
    type: CoughSessionsListActionType.ClearAllFilters;

    static create(): ClearAllFiltersAction {
        return {
            type: CoughSessionsListActionType.ClearAllFilters,
        };
    }
}

export class LoadStatusesAction implements Redux.Action {
    type: CoughSessionsListActionType.LoadStatuses;
    data: any;

    static create(response: any): LoadStatusesAction {
        return {
            type: CoughSessionsListActionType.LoadStatuses,
            data: response
        };
    }
}

export class LoadSerialNumbersAction implements Redux.Action {
    type: CoughSessionsListActionType.LoadSerialNumbers;
    data: any;

    static create(response: any): LoadSerialNumbersAction {
        return {
            type: CoughSessionsListActionType.LoadSerialNumbers,
            data: response
        };
    }
}

export class TrackingNumberSetAction implements Redux.Action {
    type: CoughSessionsListActionType.TrackingNumberSet;

    static create(): TrackingNumberSetAction {
        return {
            type: CoughSessionsListActionType.TrackingNumberSet,
        };
    }
}

export class TrackingNumberSetFailedAction implements Redux.Action {
    type: CoughSessionsListActionType.TrackingNumberSetFailed;
    error: string;

    static create(error: string): TrackingNumberSetFailedAction {
        return {
            type: CoughSessionsListActionType.TrackingNumberSetFailed,
            error: error,
        };
    }
}
